import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { processGoogleSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        const result = await processGoogleSession(sessionId);
        
        if (result.success) {
          // Clear the hash and redirect
          window.history.replaceState(null, '', '/dashboard');
          navigate('/dashboard', { replace: true, state: { user: result.user } });
        } else {
          navigate('/login', { replace: true, state: { error: result.error } });
        }
      } else {
        navigate('/login', { replace: true });
      }
    };

    processCallback();
  }, [location.hash, navigate, processGoogleSession]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9FAFB]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0A192F] mx-auto mb-4"></div>
        <p className="text-[#475569] font-body">Signing you in...</p>
      </div>
    </div>
  );
};
